import React, { Component } from "react"
import styled, { ThemeProvider } from "styled-components"
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import classnames from "classnames"

import withLocalized from "../../../localization/withLocalized"
import { media } from "../ui/utils"
import NavigationLinks from "./navigation/NavigationLinks"
import Icon from "modules/common/components/icon/Icon"
import { ICONS } from "modules/common/components/icon/Icons"
import Logo from 'modules/common/components/logo'
import themes from 'modules/common/components/ui/themes'
import { APP_THEME } from 'config'

const HeaderWrap = styled.div`
  position: fixed;
  height: 50px;
  background: black;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  ${media.minWidth(1200)`
    height: 80px;
  `}
  ${media.minWidth(1200)`
      position: relative;
  `}
`;

const Header = styled.header`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo{
    display: inline-block;
    width:124px;
    height:30px;
    margin-left: 15px;
    ${media.minWidth(1200)`
      margin-left: 45px;
      width:164px;
      height:40px;
    `}
  }
`;


const HeaderNav = styled.div`
  flex: 1 0;
  transition: 0.25s opacity ease-in-out;
  ${media.maxWidth(1199)`
    position: fixed;
    top: 50px;
    height: calc(100vh - 50px);
    background: black;
    width: 100%;
    display: none;
    ${({menuOpen}) => menuOpen && (`
      display: block;
    `)}
  `}
`;

const MenuButton = styled.button`
  position: absolute;
  top: 16px;
  right: 10px;
  background: transparent;
  height: 0px;
  width: 20px;
  padding: 14px 0 0 0;
  border-top: 2px solid white;
  border-bottom: 2px solid white;
  appearance: none;
  &:before{
    transition: transform .15s;
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    height: 2px;
    width: 100%;
    background-color: white;
    transform: translateY(-50%);
  }
  &:after{
    transition: transform .15s;
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    height: 2px;
    width: 100%;
    background-color: white;
    transform:translateY(-50%);
  }
  ${({menuOpen}) => menuOpen && (`
      border-color: transparent;
      &:before{
        transform: rotate(45deg) translateY(-50%);
      }
      &:after{
        transform: rotate(-45deg) translateY(-50%);
      }
  `)}

  ${media.minWidth(1200)`
    display: none;
  `}
`;


const BackButton = styled.button`
  width: 2.375rem;
  height: 2.375rem;
  padding: 0;
  margin: 0;
  background: transparent;
  color: white;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

class AppHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageYOffset: window.pageYOffset,
      pageYOffsetDelta: 0,
      hideHeader: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.location.state && nextProps.location.state.modal)
      return false;
    return true;
  }


  renderBackButton = () => {
    const onBackClick = () => {
      this.props.history.replace(this.props.location.state.backLink);
    };
    return (
      <BackButton onClick={onBackClick}>
        <Icon icon={ICONS.ARROW_LEFT} />
      </BackButton>
    );
  };

  render() {
    const { toggleMenu, menuOpen } = this.props;
    const headerClass = classnames({
      hideHeader: this.state.hideHeader,
    });

    return (
      <HeaderWrap className={headerClass}>
        <Header>
          <a className="logo" href="https://www.birdietime.tv/">
            <ThemeProvider theme={themes[APP_THEME]}>
              <Logo />
            </ThemeProvider>
          </a>
          <HeaderNav menuOpen={menuOpen} className="nav__header">
            <NavigationLinks
              className="nav__header-main"
              theme={APP_THEME}
            />
          </HeaderNav>
        </Header>
        <MenuButton menuOpen={menuOpen} onClick={toggleMenu} />
      </HeaderWrap>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { search } = state;

  const { query } = search;

  return {
    query
  };
};

const ConnectedAppHeader = withRouter(connect(mapStateToProps)(AppHeader));

export default withLocalized(ConnectedAppHeader);



// WEBPACK FOOTER //
// ./src/modules/common/components/app/AppHeader.js